
const formatPrice = (price) => `$${Number(price).toFixed(2)}`;

const normalize = (items = []) =>
  items.map((item) => ({
    ...item,
    Price: Number(item.Price),
    label: item.Item.toLowerCase(),
  }));

const getTodaysCharges = (fees, otherFees, oneTime, labels) => {
  const feesNorm = normalize(fees);
  const otherFeesNorm = normalize(otherFees);
  const oneTimeNorm = normalize(oneTime);
  const result = [];

  const basePlan = feesNorm[0]; 
  if (basePlan) {
    result.push({
      Item: `${labels.basePlan} (${basePlan.Item})`,
      Price: basePlan.Price,
    });
  }

  feesNorm.filter((i) => i.Price < 0).forEach((d) =>
    result.push({ Item: d.Item, Price: d.Price })
  );

  const lease = feesNorm.find((i) => i.label.includes('lease') || i.label.includes('hardware'));
  const purchase = oneTimeNorm.find((i) => i.label.includes('purchase') || i.label.includes('hardware'));

  if (lease) {
    result.push({ Item: labels.equipmentLease, Price: lease.Price });
  } else if (purchase) {
    result.push({ Item: labels.equipmentPurchase, Price: purchase.Price });
  }

  const addonTotal = otherFeesNorm.reduce((sum, i) => sum + i.Price, 0);
  if (addonTotal > 0) {
    result.push({ Item: labels.serviceAddOns, Price: addonTotal });
  }

  const oneTimeFees = oneTimeNorm.filter(
    (i) =>
      !i.label.includes('lease') &&
      !i.label.includes('installation') &&
      !i.label.includes('purchase') &&
      i.Price > 0
  );

  const oneTimeFeesTotal = oneTimeFees.reduce((sum, i) => sum + i.Price, 0);
  if (oneTimeFeesTotal > 0) {
    result.push({ Item: labels.oneTimeFees, Price: oneTimeFeesTotal });
  }

  const oneTimeCredits = oneTimeNorm.filter(
    (i) => i.Price < 0 && !['lease', 'installation'].some((k) => i.label.includes(k))
  );

  const creditsTotal = oneTimeCredits.reduce((sum, i) => sum + i.Price, 0);
  if (creditsTotal < 0) {
    result.push({ Item: labels.oneTimeCreditsApplied, Price: creditsTotal });
  }

  const setupInstallItems = oneTimeNorm.filter((i) =>
    ['lease', 'installation'].some((k) => i.label.includes(k))
  );

  const setupInstallTotal = setupInstallItems.reduce((sum, i) => sum + i.Price, 0);
  result.push({
    Item: labels.leaseSetUpAndInstallCharges,
    Price: setupInstallTotal,
  });

  return result;
};

export { formatPrice, getTodaysCharges };
